import { missingDate, missingField } from 'app/constants';
import { GridSortCellParams } from '@mui/x-data-grid-pro';
import moment from 'moment';

export const xGridNumberSortByField =
  field => (v1, v2, cellParams1: GridSortCellParams, cellParams2: GridSortCellParams) => {
    // TODO: MUI 5 - @Ferrari, find a different way to accomplish sorting by a secondary column. API is deprecated in these values
    return xGridNumberSort(
      cellParams1.api.getRow(cellParams1.id)[field],
      cellParams2.api.getRow(cellParams2.id)[field],
    );
  };

export const xGridNumberSort = (v1, v2) => {
  if (v1 === missingField && v2 === 0) return -1;
  if (v2 === missingField && v1 === 0) return 1;
  const p1 = (v1 === missingField ? 0 : v1) as number;
  const p2 = (v2 === missingField ? 0 : v2) as number;
  return p1 - p2;
};

export const xGridDateSort = (v1, v2) => {
  const p1 = moment(v1 === missingField ? missingDate : v1);
  const p2 = moment(v2 === missingField ? missingDate : v2);
  return p1.isBefore(p2) ? -1 : p1.isAfter(p2) ? 1 : 0;
};

export const xGridDateTimeSort =
  field => (v1, v2, cellParams1: GridSortCellParams, cellParams2: GridSortCellParams) => {
    return xGridDateSort(cellParams1.api.getRow(cellParams1.id)[field], cellParams2.api.getRow(cellParams2.id)[field]);
  };

export const xGridSubmissionSort = (v1, v2) => {
  // Handle null/undefined values (when no submission data is available)
  if (!v1 && !v2) return 0;
  if (!v1) return 1; // null values go to the end
  if (!v2) return -1;

  // Priority order for sorting (lower number = higher priority):
  // 1. Errors (submissionError exists)
  // 2. Manual submissions (submissionAutomated === false)  
  // 3. Automated submissions (submissionAutomated === true)
  // 4. Unknown/pending (submissionAutomated === null)
  
  const getPriority = (submission) => {
    if (submission.submissionError) return 1; // Errors first
    if (submission.submissionAutomated === false) return 2; // Manual second
    if (submission.submissionAutomated === true) return 3; // Automated third
    return 4; // Unknown/pending last
  };

  const priority1 = getPriority(v1);
  const priority2 = getPriority(v2);
  
  return priority1 - priority2;
};
